import Splide from '@splidejs/splide';
import BlurMedia from '../gsap/scrollView/_blurMedia';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideFvElements = document.getElementsByClassName('splide__fv splide'); // right-image

if (splideFvElements.length) {
  let fvSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideFvElements.length; i++) {
    let fvSlide = new Splide(splideFvElements[i], {
      // ここにオプションを設定
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      speed: 800,
      pauseOnHover: false,
      interval: 8000,
      breakpoints: {
        1025: {
        }
      }
    });

    fvSlides.push(fvSlide);

    fvSlide.on('mounted', function () {
      const blurMedias = document.querySelectorAll('.js-blur-media__picture');
      if (blurMedias) {
        BlurMedia(blurMedias);
      }
    });

    fvSlide.mount();

  }
}

const slideYellow = document.getElementsByClassName('splide__yellow splide');

if (slideYellow) {
  for (let i = 0; i < slideYellow.length; i++) {
    new Splide(slideYellow[i], {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      autoScroll: {
        speed: .4, // スクロール速度 (数値が大きいほど速くなる)
        pauseOnHover: false,
      },
      arrows: false,
      pagination: false,
    }).mount({ AutoScroll });
  }
}